import React from 'react';
import { EventRegistrationResponse } from '../generated/api/dsv-public/model';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';

type SubmissionSuccessfulFormProps = {
  eventRegistrationResponse?: EventRegistrationResponse;
};

export const SubmissionSuccessfulForm: React.FC<SubmissionSuccessfulFormProps> = ({ eventRegistrationResponse }) => {
  const { t } = useTranslation();
  return (
    <>
      <h2>{t('forms.successful-submission.title')}</h2>
      {eventRegistrationResponse?.message && parse(eventRegistrationResponse?.message)}
    </>
  );
};
